import { render, staticRenderFns } from "./SidebarIcon.vue?vue&type=template&id=67fef1a4&"
import script from "./SidebarIcon.vue?vue&type=script&lang=js&"
export * from "./SidebarIcon.vue?vue&type=script&lang=js&"
import style0 from "./SidebarIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports